exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flickity-page-dots {\n  left: 0;\n  display: block;\n  padding-top: 2.5rem;\n  position: static;\n}\n.flickity-page-dots .dot {\n  width: 1.5rem !important;\n  height: 0.25rem !important;\n  --bg-opacity: 1 !important;\n  background-color: #004876 !important;\n  background-color: rgba(0, 72, 118, var(--bg-opacity)) !important;\n  border-radius: 0 !important;\n  margin-left: 0.25rem !important;\n  margin-right: 0.25rem !important;\n}\n.flickity-viewport {\n  overflow: visible !important;\n}\n", ""]);

// exports
